import type { SaveData } from './storage';

let context: AudioContext | undefined;

export function playTone(save: SaveData, frequency = 660, duration = 0.075, shape: OscillatorType = 'sine'): void {
  if (!save.soundOn || typeof window === 'undefined') return;
  try {
    context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = shape;
    oscillator.frequency.setValueAtTime(frequency, context.currentTime);
    gain.gain.setValueAtTime(0.035, context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + duration);
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start();
    oscillator.stop(context.currentTime + duration);
  } catch {
    // Audio remains optional; gameplay does not depend on browser audio support.
  }
}

export function playPageChime(save: SaveData): void {
  playTone(save, 820, 0.06);
  window.setTimeout(() => playTone(save, 1090, 0.08), 55);
}
